import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const DebugInfo = ({ configData, categoryList }) => {
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <Paper sx={{ p: 2, m: 2, backgroundColor: '#f5f5f5' }}>
      <Typography variant="h6" gutterBottom>
        Debug Information
      </Typography>
      
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1">Config Data:</Typography>
        <Typography variant="body2" component="pre" sx={{ fontSize: '12px', overflow: 'auto' }}>
          {JSON.stringify(configData, null, 2)}
        </Typography>
      </Box>
      
      <Box sx={{ mb: 2 }}>
        <Typography variant="subtitle1">Category List Length: {categoryList?.length || 0}</Typography>
        {categoryList?.slice(0, 3).map((item, index) => (
          <Box key={index} sx={{ ml: 2, mb: 1 }}>
            <Typography variant="body2">
              Category: {item.name} | Image: {item.image}
            </Typography>
            <Typography variant="body2" color="primary">
              Full URL: {configData?.base_urls?.category_image_url}/{item.image}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default DebugInfo;